const successMessages = {
  login: 'loggedInSuccess',
  logout: 'loggedOutSuccess'
}

export default successMessages
